import { Award, CheckCircle2, ShieldCheck } from "lucide-react";

export const VerificationBadges = ({ machine, compact = false }) => {
  const badges = [
    machine?.seller_verified && { label: "Seller Verified", Icon: ShieldCheck, cls: "border-blue-500/40 bg-blue-500/15 text-blue-300" },
    machine?.machine_verified && { label: "Machine Verified", Icon: CheckCircle2, cls: "border-emerald-500/40 bg-emerald-500/15 text-emerald-300" },
    machine?.inspection_verified && { label: "Inspection Verified", Icon: Award, cls: "border-amber-500/40 bg-amber-500/15 text-amber-300" },
  ].filter(Boolean);

  return (
    <div className="flex flex-wrap gap-2" data-testid={`verification-badges-${machine?.id || "seller"}`}>
      {badges.map(({ label, Icon, cls }) => (
        <span key={label} className={`inline-flex items-center gap-1.5 border px-2 py-1 text-[10px] font-bold uppercase ${cls}`}>
          <Icon className="h-3.5 w-3.5" /> {!compact && label}
        </span>
      ))}
    </div>
  );
};